const AuthenticationDefaultSteps={
    CREATE_PAYMENT:'CreatePayment',
    SET_ITEMS:'SetItems',
    PAYMENT_INQUIRY:'InquiryPayment',
    SHAHKAR:'Shahkar',
    INIT_CONFIRM:'InitConfirm',
    NID_CARD_READER:"NIDCardReader",
    COMPARE_FACES:"CompareFaces",
    VIDEO_VALIDATION:"VideoValidation",
    IAuth:"IAuth",
    AUTO_NID_CARD:"AutoNIDCard",
    FINAL:"Final",

}
const DefaultTexts = {
    "InitConfirm":{
        title:"تکمیل اطلاعات"
    },
    "CreatePayment":{
        title:"پرداخت"
    },
    "PaymentInquiry":{
        title:"پرداخت"
    },
    "NIDCardReader": {
        title:"عکس کارت ملی"
    },
    "Shahkar": {
        title:"ساخت فرایند جدید"
    },
    "CompareFaces": {
        title:"احراز هویت تصویری"
    },
    "VideoValidation": {
        title:"احراز هویت ویدیویی"
    },

};

export {AuthenticationDefaultSteps,DefaultTexts}